import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadAttachmentVesselAnnouncementDocumentDisplayModel } from '@common/models/uploadAttachmentVesselAnnouncementDocument.display.model';
import { Subject } from 'rxjs';
import { DocumentTypes } from '@common/knownTypes/documentTypes';
import { includes } from 'lodash';

@Component({
    selector: 'app-pdf-signer-modal',
    templateUrl: './pdf-signer-modal.component.html',
})
export class PdfSignerModalComponent implements OnInit {
    public title: string;
    public documentId: number;
    public file: any;
    public selectedCertificate: string;
    public id: number;
    public blobFile: any;
    public signedFile: any;
    public documentType: string;

    showSaveAndSendButton = false;
    showOnlySaveButton = false;
    refreshDocumentSubject: Subject<any> = new Subject<any>();
    documentTypes = DocumentTypes;

    // documents we sign and send to cimis
    docTypesSendingToCimis: string[] = [
        DocumentTypes.ISPS,
        DocumentTypes.DEKLOT,
        DocumentTypes.DOS,
        DocumentTypes.OTP_ISP,
        DocumentTypes.SIO
    ];

    // documents we only sign and don't send to cimis
    docTypesWithoutSendingToCimis: string[] = [
        DocumentTypes.DEKLOT_TRUCK,
        DocumentTypes.DEKLOT_WAGON
    ];

    constructor(
        public activeModal: NgbActiveModal
    ) {}

    ngOnInit() {
        this.showSaveAndSendButton = includes(this.docTypesSendingToCimis, this.documentType);
        this.showOnlySaveButton = includes(this.docTypesWithoutSendingToCimis, this.documentType);
    }

    sign($event) {
        this.signedFile = $event;
    }

    reloadFile() {
        this.refreshDocumentSubject.next(this.file);
    }

    /**
     * Send signed PDF to Cimis and save it to db if cimis response is OK
     * sendToCimis = true will directly send the signed document to cimis and save it as an attachment
     * sendToCimis = false will just save the attachment
     */
    persistPdf(sendToCimis: boolean) {
        const model: UploadAttachmentVesselAnnouncementDocumentDisplayModel = {
            name: this.title,
            attachmentId: this.id,
            fileAsBase64: this.signedFile,
            documentId: this.documentId,
            extension: 'PDF',
            scannedForm: null,
            validationErrors: null,
            sendToCimis: sendToCimis
        };

        this.activeModal.close(model);
    }
}
